import { Routes, Route } from "react-router-dom";
import { NotFound } from "../components/common";
import Edit from "../pages/Quest/Edit";
import Home from "../pages/Quest/Home";

const Quest = () => {
  return (
    <div className="Quest">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id/edit" element={<Edit />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Quest;
